import {FieldAdapter} from '../field-factory';
import {InputBase} from '@mantine/core';
import {FC, useContext} from 'react';
import {ReadOnlyContext} from '../readonly-context';
import {IMaskInput} from 'react-imask';

export type $PhoneNumberInputAdapterProps = {
  placeholder?: string;
  label?: string;
  onChange?: (value?: string) => void;
  disabled?: boolean;
  required?: boolean;
};

export const $PhoneNumberInputAdapter: FC<
  FieldAdapter<$PhoneNumberInputAdapterProps>
> = ({inputProps: {onChange, disabled, ...inputProps}, control}) => {
  const {
    field: {onChange: fieldOnChange, ref, ...fieldProps},
    fieldState: {invalid},
  } = control;

  const {readOnly} = useContext(ReadOnlyContext);

  return (
    <InputBase
      error={invalid}
      inputRef={ref}
      disabled={disabled || readOnly}
      component={IMaskInput}
      unmask
      onAccept={(value: any) => {
        fieldOnChange(value);
        onChange?.(value);
      }}
      mask="(000) 000-0000"
      {...fieldProps}
      {...inputProps}
    />
  );
};